import { render, staticRenderFns } from "./importOwner.vue?vue&type=template&id=87ce7668&scoped=true"
import script from "./importOwner.vue?vue&type=script&lang=js"
export * from "./importOwner.vue?vue&type=script&lang=js"
import style0 from "./importOwner.vue?vue&type=style&index=0&id=87ce7668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ce7668",
  null
  
)

export default component.exports